import {
  area,
  multiselect,
  minMax,
  dateRange,
} from '../../../packages/configs/filter-builder';

export const filters = [
  {
    type: 'PARENT',
    label: 'Completed Investments',
    source: 'medc_opps_all',
    dataKey: 'opp_id',
    filters: [
      area(),
      multiselect({
        key: 'cluster',
        label: 'Submarket',
        options: [
          {
            label: 'Pick a filter',
            value: 'EMPTY',
          },
          {
            label: 'Weak',
            value: 3,
          },
          {
            label: 'Middle',
            value: 1,
          },
          {
            label: 'Strong',
            value: 2,
          },
        ],
      }),
      multiselect({
        key: 'city_name',
        label: 'City',
      }),
      multiselect({
        key: 'county_name',
        label: 'County',
      }),
      multiselect({
        key: 'prosperity_region',
        label: 'Prosperity Region',
      }),
      // multiselect({
      //   key: 'property_type',
      //   label: 'Property Type',
      // }),
      {
        key: 'opp_type_combo',
        label: 'Deal Type',
        type: 'MULTISELECT',
        operator: 'contains',
        options: [
          {
            label: 'Pick a filter',
            value: 'EMPTY',
          },
          {
            label: 'Brownfield',
            value: 'Brownfield',
          },
          {
            label: 'CDBG',
            value: 'CDBG',
          },
          {
            label: 'CRP',
            value: 'CRP',
          },
          {
            label: 'Patronicity',
            value: 'Patronicity',
          },
        ],
      },
      minMax({
        key: 'opp_totalprivateinvestment',
        label: 'Private Investment ($)',
      }),
      minMax({
        key: 'opp_totalincentiveamount',
        label: 'MEDC Investment ($)',
      }),
      minMax({
        key: 'opp_totalprojectamount',
        label: 'Total Investment ($)',
      }),
      minMax({
        key: 'opportunity_impact_res',
        label: 'Residential Impact ($)',
      }),
      minMax({
        key: 'opportunity_impact_com',
        label: 'Commercial Impact ($)',
      }),
      minMax({
        key: 'total_impact',
        label: 'Total Impact ($)',
      }),
      minMax({
        key: 'bcr',
        label: 'Benefit Cost Ratio',
      }),
      dateRange({
        key: 'start_date',
        label: 'Deal Date',
      }),
      multiselect({
        key: 'has_grant',
        label: 'Has Grant',
        options: [
          {
            label: 'Pick a filter',
            value: 'EMPTY',
          },
          {
            value: 1,
            label: 'Yes',
          },
          {
            value: 0,
            label: 'No',
          },
        ],
      }),
      multiselect({
        key: 'has_loan',
        label: 'Has Loan',
        options: [
          {
            label: 'Pick a filter',
            value: 'EMPTY',
          },
          {
            value: 1,
            label: 'Yes',
          },
          {
            value: 0,
            label: 'No',
          },
        ],
      }),
    ],
  },
];
